













routes = require '../routes.coffee'

module.exports = {
  components:
    globalBoxes: require('./shared/global_boxes.vue')

  beforeRouteEnter: (to, from, next) ->
    ActionCable.connect() unless ActionCable.cable
    routes.guards.session(to, from, next)

  data: ->
    is_authorized: Session.authorized
    show_notifications: true

  methods:
    initializeIntercom: ->
      @intercom = new IntercomCtrl
      Session.addCallback 'session_finished', @sessionFinishCallback
      Session.addCallback 'session_started', @resetStorage
      Session.addCallback 'session_started', @sessionStartCallback
      @intercom.start current_user: Session.current_user, current_company: Session.current_company, hash: Session.current_user.user_hash if Session.authorized

    loadPlivoSdk: ->
      plivo = document.createElement('script')
      plivo.setAttribute('src', 'https://cdn.plivo.com/sdk/browser/v2/plivo.min.js')
      document.head.appendChild(plivo)

    sessionFinishCallback: ->
      @is_authorized = false
      @intercom.finish()

    sessionStartCallback: ->
      @is_authorized = true
      @intercom.start

    resetStorage: ->
      @$store.commit 'resetUsers'
      @$store.commit 'resetTemplateCategories'
      @$store.commit 'resetTags'
      @$store.commit 'resetNotifications'

    intercepted: (e) ->
      link = document.getElementById('header-wrapper')

      if e.data.current_user?.id && e.data.type == 'login'
        e.data.current_user.new_ui = true
        Session.signIn(e.data.current_user)
        @updateLocale()
        link.style.display = 'none'
        @show_notifications = false
        if e.data.route
          @$router.push e.data.route
      if e.data.type == 'navigate-to-flow'
        Session.current_user.new_ui = true
        @$router.push e.data.route
      if e.data.type == 'logout'
        Session.logout @logoutSuccess
      if e.data.type == 'get-current-user'
        window.parent.postMessage({ type: 'current-user', current_user: JSON.stringify(Session.current_user) }, '*')
      if e.data.user?.id && e.data.type == 'change-company'
        e.data.user.new_ui = true
        Session.signIn(e.data.user)

    logoutSuccess: ->
      Session.logout()
    
    updateLocale: ->
      locale = Session.current_user.selectedLanguage().replace('-', '_')
      return if !locale

      @$i18n.locale = locale
      if locale == 'en_US'
        moment.updateLocale('en-us', momentLocales.en_US)
      else if locale == 'es'
        moment.updateLocale('es', momentLocales.es)
      else
        moment.updateLocale('pt-br', momentLocales.pt_BR)

  created: ->
    @mixpanel = new MixpanelCtrl
    if window.addEventListener
      window.addEventListener 'message', @intercepted, false
    else if window.attachEvent
      window.attachEvent 'on' + 'message', @intercepted
    window.parent.postMessage { type: "created" }, "*" if window.parent

  mounted: ->
    Loader.off()
    @usersResource = new UsersResource()
    @initializeIntercom()
    @loadPlivoSdk()
    window.parent.postMessage { type: "app-mounted" }, "*" if window.parent
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/App.vue